import React from "react"

export const onClientEntry = () => {
  console.log("Gatsby client loaded")
}